export const getLocale = (): string => {
  return (
    document.documentElement.dataset.locale ||
    document.documentElement.lang ||
    'en'
  )
}
